import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem/ListItem";
import List from "@material-ui/core/List/List";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Grid from "@material-ui/core/Grid/Grid";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import Typography from "@material-ui/core/Typography/Typography";
import { isFunction } from "lodash";
import InformationTag from "@configuratorware/configurator-frontendgui/App/Shared/Components/InformationTag/InformationTag";
import {
  translationExists,
  t,
} from "@configuratorware/configurator-frontendgui/Framework/i18n";
import clsx from "clsx";
import Tooltip from "@material-ui/core/Tooltip";

const styles = (theme) => ({
  MuiListRoot: {
    paddingTop: 0,
    paddingRight: 0,
    paddingLeft: 0,
    height: "auto",
    [theme.breakpoints.up("sm")]: {},
  },
  MuiCheckboxRoot: {
    /* margin: '0 0 0 12px',
        padding: 0,
        [theme.breakpoints.down('xs')]: {
            margin: '0',
        },
        display: 'flex !important', */
    margin: 0,
    marginLeft: 1,
    [theme.breakpoints.up("sm")]: {
      marginTop: 18,
      marginBottom: 20,
      marginLeft: 4,
    },
    "& label": {
      fontSize: 15,
      color: "grey",
    },
    "& .MuiIconButton-colorSecondary:hover": {
      background: "transparent",
    },
  },
  MuiTypographyRoot: {
    lineHeight: 1.8,
  },
  MuiTypographyNoWrap: {
    whiteSpace: "nowrap",
    minWidth: 50,
    fontSize: 15,
    padding: "0 16px",
  },
  gutterBottom: {
    marginBottom: 0,
  },
  itemTitle: {
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  listItemPrimary: {
    paddingRight: "16px",
    [theme.breakpoints.down("xs")]: {
      padding: 0,
    },
    "& span": {
      fontSize: 15,
      overflow: "hidden",
      textOverflow: "ellipsis",
      minWidth: "160px",
      display: "block",
      [theme.breakpoints.down("md")]: {
        minWidth: 140,
      },
      [theme.breakpoints.down("xs")]: {
        minWidth: 50,
      },
    },
  },
  selectableLabel: {
    padding: "0 10px",
    [theme.breakpoints.down("xs")]: {
      padding: 0,
    },
  },
  infoBtn: {
    flex: "100%",
    [theme.breakpoints.down("xs")]: {
      flex: 0,
      justifyContent: "flex-end",
      display: "flex",
    },
  },
  tooltip: {},
  MuiListUnselectable: {
    paddingLeft: 44,
    [theme.breakpoints.up("sm")]: {
      paddingLeft: 55,
    },
  },
  isDisabled: {
    "& .MuiTypography-root": {
      color: "grey",
    },
  },
});

class PriceList extends React.Component {
  static propTypes = {
    list: PropTypes.array,
    productTitle: PropTypes.string,
    classes: PropTypes.object,
    amount: PropTypes.number,
    totalPrice: PropTypes.string,
    taxNote: PropTypes.string,
    hidePrices: PropTypes.bool,
    showReceiveOfferForm: PropTypes.bool,
    onSelectableChanged: PropTypes.func,
  };

  constructor(props) {
    super(props);
  }

  handleToggle = (element) => () => {
    if (isFunction(this.props.onSelectableChanged)) {
      this.props.onSelectableChanged(element.key, !element.selected);
    }
  };

  render() {
    const { list, productTitle, classes, amount, hidePrices } = this.props;
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {amount > 0 && list && list.length <= 0 && (
            <List dense={false}>
              <ListItem
                classes={{
                  root: classes.MuiListRoot,
                }}
              >
                <Typography
                  variant="body2"
                  gutterBottom
                  classes={{
                    root: classes.MuiTypographyNoWrap,
                    gutterBottom: classes.gutterBottom,
                  }}
                >
                  {amount} {t("amountPrice.pieces")}
                </Typography>

                <ListItemText
                  className={classes.listItemPrimary}
                  primary={productTitle}
                />
              </ListItem>
            </List>
          )}
          {list && list.length > 0 && (
            <List dense={false}>
              {list.map((element) => {
                if (!element.dontRender) {
                  return (
                    <ListItem
                      key={element.key}
                      classes={{
                        root: clsx(
                          classes.MuiListRoot,
                          !element.selectable && classes.MuiListUnselectable
                        ),
                      }}
                    >
                      {element.selectable && (
                        <Checkbox
                          checked={element.selected}
                          color="primary"
                          tabIndex={-1}
                          disableRipple
                          disabled={!!element.isDisabled}
                          onChange={this.handleToggle(element)}
                          classes={{
                            root: classes.MuiCheckboxRoot,
                          }}
                        />
                      )}

                      <ListItemText
                        className={clsx(
                          list[0].key === element.key && classes.itemTitle,
                          list[0].key !== element.key &&
                            classes.listItemPrimary,
                          element.selectable && classes.selectableLabel,
                          element.isDisabled && classes.isDisabled
                        )}
                        primary={element.label}
                        secondary={element.tooltip || null}
                      />
                      {element.tooltipText && (
                        <InformationTag infoText={element.tooltipText} />
                      )}
                      {element.key === "setup_cost" &&
                        translationExists("setUpCostInformation") && (
                          <div className={classes.infoBtn}>
                            <InformationTag
                              infoText={t("setUpCostInformation")}
                            />
                          </div>
                        )}
                      {element.key === "production_cost" &&
                        translationExists("productionCostInformation") && (
                          <div className={classes.infoBtn}>
                            <InformationTag
                              infoText={t("productionCostInformation")}
                            />
                          </div>
                        )}
                      {!hidePrices && (
                        <Typography
                          variant="body2"
                          gutterBottom
                          align="right"
                          classes={{
                            root: classes.MuiTypographyNoWrap,
                            gutterBottom: classes.gutterBottom,
                          }}
                        >
                          {element.selectable && !element.selected
                            ? ""
                            : element.price}
                        </Typography>
                      )}
                    </ListItem>
                  );
                }
              })}
            </List>
          )}
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles, { name: "PriceList" })(PriceList);
